import React from 'react';
import PropTypes from 'prop-types';
import BasicPortlet from '../../../../commonComponents/portlets/BasicPortlet';
import TrophyDisplay from './TrophyDisplay';
import TrophyConfigProp from '../../propTypes/trophyConfigProp';
import Carousel from '../../../../commonComponents/carousel/Carousel';

export default function TrophyPortlet({ title, trophyConfig, onSelect }) {
  return (
    <div className="row">
      <div className="col-12">
        <BasicPortlet title={title}>
          <div className="row">
            <Carousel>
              {trophyConfig.map(trophy => (
                <TrophyDisplay
                  key={trophy.imageURL}
                  trophy={trophy}
                  onSelect={() => onSelect(trophy)}
                />
              ))}
            </Carousel>
          </div>
        </BasicPortlet>
      </div>
    </div>
  );
}

TrophyPortlet.propTypes = {
  title: PropTypes.string.isRequired,
  trophyConfig: PropTypes.arrayOf(PropTypes.shape(TrophyConfigProp.propType))
    .isRequired,
  onSelect: PropTypes.func.isRequired,
};
